import React from 'react';
import {styled} from '@mui/material/styles';
import {Box, CircularProgress} from "@mui/material";
import {useSelector} from "react-redux";
import grey from "@mui/material/colors/grey";
// TODO: Remove when fixed mobile downloads
import GetAppIcon from '@mui/icons-material/GetApp';
import Tooltip from "@mui/material/Tooltip";


const progressSize = 100;

const StyledPaper = styled(Box)(({theme, loaded}) => ({
    backgroundColor: grey[900],
    height: loaded ? 'auto' : '90vh',
    maxWidth: '97%',
    maxHeight: '97%',
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
        minWidth: theme.breakpoints.values.sm,
    },
}));

const StyledProgress = styled(CircularProgress)(({theme, loaded}) => ({
    color: grey[800],
    position: 'absolute',
    left: '50%',
    top: '50%',
    marginTop: -progressSize/2,
    marginLeft: -progressSize/2,
}));

const StyledFab = styled(Box)(({theme, saveVisible}) => ({
    position: "absolute",
    bottom: theme.spacing(3),
    right: theme.spacing(2),
    opacity: saveVisible ? 1 : 0,
    visibility: saveVisible ? 'visible' : 'hidden',
    transitionProperty: 'opacity, visibility',
    transitionDuration: '0.25s',
}));

const StyledSaveLink = styled('a')(({theme, loaded}) => ({
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    visibility: loaded ? 'visible' : 'hidden',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
    width: 'calc(100%)',
    height: 'calc(100%)',
    top: 0,
    left: 0,
    position: 'absolute',
}));


export default function SaveButton(props) {

    const [saveVisible, setSaveVisible] = React.useState(true);

    // Redux state
    const lastEdited = useSelector(state => state.image.lastEdited);
    const currentURL = useSelector(state => state.image.currentURL);
    const file = useSelector(state => state.image.file);

    const showButton = async () => {
        console.log('asdf');
        setSaveVisible(true);
        await new Promise(r => setTimeout(r, 3000));
        setSaveVisible(false);
    }

    const downloadImage = () => {
        var link = document.createElement("a"); // Or maybe get it from the current document
        link.href = currentURL;
        link.download = `edited-image.png`;
        document.body.appendChild(link);
        link.click();
    }

    const getFilename = () => {
        const date = new Date((lastEdited ?? new Date().toISOString()));
        return `${file?.name.split('.')[0]}-oledified_${date.toLocaleString()}.png`
    }

    // TODO: Make only show up after hovered for a few seconds on desktop (or tapped on mobile)
    return (
        <Tooltip title={'Click to download'} followCursor arrow placement={'top-start'} enterDelay={2000}>
            <StyledSaveLink href={currentURL} download={getFilename()} alt={'Save image'} loaded={currentURL ? 1 : 0}>
                <GetAppIcon/>
            </StyledSaveLink>
        </Tooltip>
    );
}
